import React from 'react'
import { Stack } from '@tumelo/designsystem'
import { HeaderLinksListItems } from './HeaderLinksListItems'

export const HeaderNavigation: React.FC = () => {
  return (
    <nav>
      <Stack as="ul" flexDirection="row" flexWrap>
        <HeaderLinksListItems />
      </Stack>
    </nav>
  )
}
